// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ygaR","type":"styles_type__1dDI0","choices":"styles_choices__gbROE"};